import { render, staticRenderFns } from "./chart-base.vue?vue&type=template&id=c87df75c"
import script from "./chart-base.vue?vue&type=script&lang=js"
export * from "./chart-base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c87df75c')) {
      api.createRecord('c87df75c', component.options)
    } else {
      api.reload('c87df75c', component.options)
    }
    module.hot.accept("./chart-base.vue?vue&type=template&id=c87df75c", function () {
      api.rerender('c87df75c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/components/chart/chart-base.vue"
export default component.exports